<dt-table-layout *dtDataLoad="tags != null; error: hasError" [isLoading]="isLoading">
  <form header class="cp-filters-form" [formGroup]="filterForm" (ngSubmit)="triggerLoadSubject.next()">
    <mat-form-field subscriptSizing="dynamic" class="search-query">
      <mat-label i18n>Zielbaumname</mat-label>
      <input type="text" formControlName="searchQuery" matInput />
    </mat-form-field>
    <dt-tag-input [allTags]="tags" formControlName="tags" i18n>Nach Tags filtern</dt-tag-input>

    <div class="filler"></div>
    <button mat-raised-button color="primary" (click)="openModal()"
      ><mat-icon>add</mat-icon><ng-container i18n>Zielbaum erstellen</ng-container></button
    >
  </form>

  <table
    mat-table
    [dataSource]="items"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="sort.sortBy"
    [matSortDirection]="sort.sortDirection"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="nameDe">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Deutscher Name</th>
      <td mat-cell *matCellDef="let row">
        @if (!row.name.de) {
          <i>Kein Name</i>
        }
        {{ row.name.de }}
      </td>
    </ng-container>
    <ng-container matColumnDef="nameEn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Englischer Name</th>
      <td mat-cell *matCellDef="let row">
        @if (!row.name.en) {
          <i>Kein Name</i>
        }
        {{ row.name.en }}
      </td>
    </ng-container>
    <ng-container matColumnDef="totalAccumulatedScore">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Verwendet</th>
      <td mat-cell *matCellDef="let row">{{ row.totalAccumulatedScore | number: '1.0-1' }}</td>
    </ng-container>
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef i18n>Tags</th>
      <td mat-cell *matCellDef="let row">
        <dt-tag-list
          [tagIds]="row.tags"
          [tagsById]="tagsById"
          [selectedTagIds]="filterForm.value.tags"
          (tagClick)="tagClick($event.id)"
        ></dt-tag-list>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Erstellt am</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openModal(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Zielbäume entsprechen dem Filter.</td>
    </tr>
  </table>

  <mat-paginator
    [pageSize]="page.pageSize"
    [pageIndex]="page.pageIndex"
    [length]="itemCount"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  ></mat-paginator>
</dt-table-layout>
